import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { LearnerImportSummary, LearnerImportSummaryDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    importLearners(schoolId: string, file: File): Observable<LearnerImportSummary> {
        const formData = new FormData();
        formData.append('file', file);

        return this.httpClient
            .post<LearnerImportSummaryDto>(`schools/${schoolId}/users/import`, formData)
            .pipe(map((response) => new LearnerImportSummary(response)));
    }

    downloadLearnersTemplate(): Observable<Blob> {
        return this.httpClient.get('schools/learners/import-template', { responseType: 'blob' });
    }
}
